/* mm-faq2.js — FAQ: erst Themen, dann Fragen. Mit Suche.
 *
 * 29.08.2026, Mert: „faq immer noch unübersichtlich. Mach das schlauer, mach das
 * kreativer mit Animationen und so weiter. Auch leichter, das ist viel zu kompliziert."
 *
 * WAS VORHER SCHIEFLIEF
 *   Neun Reiter in einer Wischleiste vor 24 Fragen. Wer eine Antwort suchte, musste
 *   erst waagerecht wischen, um ueberhaupt zu sehen, welche Themen es gibt - und danach
 *   raten, in welchem seine Frage steckt. Merts eigene 21st-Sammlung „FAQ" hilft hier
 *   nicht weiter: alle drei gemerkten Bausteine sind genau das, was schon da war
 *   (Reiterleiste + Aufklapper). Das Problem war nie der Aufklapper, sondern die Menge.
 *
 * DER NEUE AUFBAU - zwei Stufen statt einer Leiste
 *   Stufe 1: fuenf Themenkacheln in einem Raster. Alle gleichzeitig sichtbar, ohne
 *            Wischen, jede mit Anzahl. Man sieht auf einen Blick, was es gibt.
 *   Stufe 2: Antippen oeffnet nur die 3-6 Fragen dieses Themas, darueber ein
 *            Zurueck-Knopf. Kurze Liste statt Wand.
 *   Quer dazu: eine SUCHE. Wer „müde" tippt, bekommt die Antwort sofort, egal in
 *            welchem Thema sie steckt - das ist der eigentliche Abkuerzer.
 *
 * ES WIRD NICHTS GELOESCHT (Mert, 29.08.2026: „nix löschen bei den antworten").
 *   Alle 24 Fragen und ihre Originaltexte bleiben, sie werden nur anders sortiert:
 *   aus neun Gruppen werden fuenf, jede mit 3 bis 6 Fragen.
 *
 * Fragen und Antworten kommen weiter zur LAUFZEIT aus dem alten Sternify-FAQ
 * (Original-HTML, nicht abgetippt) - die Texte sind rechtlich sorgfaeltig formuliert.
 * Die Avatar-Spalte wird mit hereingeholt, nicht kopiert.
 *
 * FARBEN: 01.09.2026, Mert: Jedes Thema bekommt eine eigene Farbe. Die Farben
 * bleiben klar getrennt; jede Kachel verwendet genau einen Farbton statt eines
 * beliebigen Rot-Pink-Verlaufs. Die vorhandene Struktur und alle Antworten bleiben.
 */
(function () {
  'use strict';

  var K = 'cubic-bezier(.22,.61,.36,1)';
  var ROT = '#E5142A';
  var ruhig = window.matchMedia &&
              window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Fuenf Themen. Es gewinnt der ERSTE Treffer - die Reihenfolge ist also Teil der
     Zuordnung. Bei Aenderungen immer gegen ALLE Fragen gegenpruefen, nicht nur gegen
     die eigene. (Beispiel: „wie viel" faengt sonst auch „Wie viel nehme ich ein".) */
  var THEMEN = [
    ['dich', 'Für dich', 'Passt das überhaupt zu mir?',
     /für wen|was macht magic milk|nehme trotzdem nicht zu|kraftsport|fitness|kampfsport|verbrenne alles|rund ums training/i,
     '#FF4B7E', '255,75,126'],
    ['menge', 'Wie viel', 'Wie viele Packungen, welche Sorte',
     /wie viele packungen|schnellem stoffwechsel|welche sorte|unterschied zwischen strawberry/i,
     '#F5A044', '245,160,68'],
    ['anwendung', 'Anwendung', 'Einnahme, Pausen, Aufhören',
     /wie nehme ich|anwend|dosier|zubereit|trinke|absetz|aufhör|höre ich|einnahmepaus/i,
     '#54C9BA', '84,201,186'],
    ['inhalt', 'Inhalt & Sicherheit', 'Was drin ist und was es macht',
     /protein-shake|kombinieren|untersucht|labor|unbedenk|nebenwirk|verträg|allerg|schwanger|gesundheit|müde|garantie/i,
     '#8CCB68', '140,203,104'],
    ['original', 'Original & Preis', 'Echtheit, Fälschungen, Preis',
     /original bekomme|ausgerechnet bei euch|woanders günstiger|haftung|nicht billiger/i,
     '#E5142A', '229,20,42']
  ];

  var FARBEN = {};
  THEMEN.forEach(function (thema) {
    FARBEN[thema[0]] = { farbe: thema[4], rgb: thema[5] };
  });

  function farbStil(thema, index) {
    var farbe = FARBEN[thema] || { farbe: ROT, rgb: '229,20,42' };
    return '--i:' + index + ';--mmF2farbe:' + farbe.farbe + ';--mmF2rgb:' + farbe.rgb;
  }

  /* Schlichte Strichzeichen, eine Linie je Thema. Keine Emoji-Ketten. */
  var ZEICHEN = {
    dich: '<circle cx="12" cy="8" r="3.4"/><path d="M5.5 20c.7-3.6 3.3-5.4 6.5-5.4S17.8 16.4 18.5 20"/>',
    menge: '<path d="M4 8.5 12 4l8 4.5v7L12 20l-8-4.5z"/><path d="M4 8.5 12 13l8-4.5M12 13v7"/>',
    anwendung: '<path d="M8 3h8M9.5 3v4.2L5.8 17.4A2.4 2.4 0 0 0 8 20.8h8a2.4 2.4 0 0 0 2.2-3.4L14.5 7.2V3"/><path d="M7.2 14h9.6"/>',
    inhalt: '<path d="M12 3.2 4.6 6v5.6c0 4.4 3 8.1 7.4 9.2 4.4-1.1 7.4-4.8 7.4-9.2V6z"/><path d="m9.2 12 2 2 3.6-3.8"/>',
    original: '<circle cx="12" cy="10" r="5.2"/><path d="m9.4 14.6-1.2 6L12 18.6l3.8 2-1.2-6"/>'
  };

  /* Die Antworten kommen aus den Theme-Einstellungen und duerfen dort kein <img>
     enthalten - Shopify raeumt Rich-Text-Felder auf. Deshalb steht in der Antwort
     nur ein Platzhalter, und das Bild wird hier eingesetzt. */
  var GRAFIK = {
    'BILD-MUEDIGKEIT': {
      q: 'https://cdn.shopify.com/s/files/1/0958/0465/3955/files/mm-faq-muedigkeit.jpg?v=1788004158',
      b: 'Warum macht Magic Milk am Anfang müde — illustrierte Darstellung der Anfangsphase',
      u: 'Illustrative Darstellung. Zum Vergrößern antippen.'
    }
  };

  function grafikEinsetzen(html) {
    return html.replace(/(?:<p>\s*)?\[\[([A-Z-]+)\]\](?:\s*<\/p>)?/g, function (alles, name) {
      var g = GRAFIK[name];
      if (!g) return '';
      return '<figure class="mmF2bild">' +
             '<a href="' + g.q + '&width=1400" target="_blank" rel="noopener">' +
             '<img src="' + g.q + '&width=640" alt="' + g.b + '" ' +
             'width="940" height="1672" loading="lazy" decoding="async"></a>' +
             '<figcaption>' + g.u + '</figcaption></figure>';
    });
  }

  var css = [
    '#mmFaq2{--mmF2farbe:#E5142A;--mmF2rgb:229,20,42;flex:1 0 100%;width:100%;max-width:100%;min-width:0;box-sizing:border-box;',
      'background:#151013;color:#F3E9EC;padding:clamp(34px,5vw,60px) 0;position:relative;',
      'overflow:hidden}',
    '#mmFaq2 *{box-sizing:border-box}',
    /* Das Theme faerbt Text in Knoepfen schwarz (gemessen: rgb(0,0,0) auf
       .mmF2tname). Auf dunklem Grund ist das unlesbar - deshalb erben alle
       Spannen im Knopf die Farbe des Knopfes, und die Titel bekommen sie
       zusaetzlich ausdruecklich. */
    '#mmFaq2 button span{color:inherit}',
    '#mmFaq2 .mmF2schein{position:absolute;top:-290px;left:50%;width:min(980px,120vw);height:560px;',
      'transform:translateX(-50%);border-radius:50%;pointer-events:none;',
      'background:radial-gradient(circle at 18% 58%,rgba(255,75,126,.15),transparent 36%),',
      'radial-gradient(circle at 50% 42%,rgba(245,160,68,.10),transparent 34%),',
      'radial-gradient(circle at 82% 60%,rgba(84,201,186,.13),transparent 37%);filter:blur(52px)}',
    '#mmFaq2 .mmF2innen{position:relative;z-index:1;max-width:760px;margin:0 auto;',
      'padding:0 clamp(16px,3vw,24px)}',
    '#mmFaq2 .mmF2kopf{text-align:center;margin-bottom:14px}',
    /* 02.09.2026: ruhiges Korall statt hartem Rot; nur einmal beim Hinsehen. */
    '#mmFaq2 .mmF2auge{display:inline-flex;align-items:center;gap:7px;margin:0 0 10px;',
      'font-weight:800;font-size:.62rem;letter-spacing:.13em;word-spacing:-.12em;',
      'text-transform:uppercase;',
      'color:#FF7185;opacity:0;transform:translateY(9px);',
      'transition:opacity .58s ' + K + ',transform .58s ' + K + '}',
    'html body #mmFaq2 .mmF2kopf .mmF2auge{color:#FF7185!important;',
      '-webkit-text-fill-color:#FF7185!important}',
    '#mmFaq2 .mmF2auge:before{content:"";width:16px;height:2px;background:#FF7185;',
      'transform:scaleX(0);transform-origin:right center;transition:transform .52s ' + K + ' .12s}',
    '#mmFaq2.sichtbar .mmF2auge{opacity:1;transform:none}',
    '#mmFaq2.sichtbar .mmF2auge:before{transform:scaleX(1)}',
    /* 29.08.2026, Mert: „F.A.Q. Überschrift Groß und weiss wieder vor".
       Sie war zu klein geworden UND wirkte dunkelgrau: mm-textanim.js zerlegt
       Überschriften in Wort-Spannen und blendet sie einzeln ein - stand die
       Sektion beim Messen still, blieben die Spannen halb durchsichtig hängen.
       Diese Überschrift ist deshalb von der Einblendung ausgenommen: immer voll
       deckend, immer #F3E9EC. */
    /* 29.08.2026, Merts Wahl im Schriftportal: Bebas Neue. Sie liegt als
       „MM Bebas" bereits per @font-face im Theme (seit den Abo-Kacheln) - also
       kein zweiter Ladevorgang. Bebas hat nur Versalien und laeuft schmal,
       deshalb darf sie deutlich groesser stehen und braucht etwas Laufweite
       statt der negativen Sperrung, die zu Poppins gehoerte. */
    '#mmFaq2 h2{font-family:"MM Bebas","Bebas Neue",Impact,sans-serif;',
      'font-size:clamp(2.7rem,8vw,4.5rem)!important;line-height:.94!important;letter-spacing:.012em;',
      'margin:0;font-weight:400;color:#F3E9EC}',
    '#mmFaq2 h2 span,#mmFaq2 h2 .mmTA{color:#F3E9EC!important;opacity:1!important;',
      'transform:none!important;-webkit-text-fill-color:#F3E9EC!important;',
      'font-family:inherit!important;font-size:inherit!important;line-height:inherit!important;',
      'letter-spacing:inherit!important;font-weight:inherit!important}',

    /* Avatare bleiben - sie sind der Sozialnachweis, den Mert ausdruecklich wollte. */
    '#mmFaq2 .mmF2avatare{display:flex;justify-content:center;margin:0 0 14px}',
    '#mmFaq2 .mmF2avatare .st_faq-title{display:none!important}',
    '#mmFaq2 .mmF2avatare .st_faq-social-proof{margin-top:0!important}',
    '#mmFaq2 .mmF2avatare .st_faq-left-column{max-width:540px;text-align:center;',
      'background:transparent!important;padding:0!important;margin:0!important;border:0!important}',
    '#mmFaq2 .mmF2avatare *{color:rgba(243,233,236,.55)!important}',
    /* 03.09.2026: Erst kurz lesen lassen, dann die drei Avatare einzeln.
       Die Grundverzoegerung verhindert, dass sie schon beim ersten Pixel
       Sichtkontakt fertig sind; der bestehende Links-nach-rechts-Auftritt bleibt. */
    '#mmFaq2 .mmF2avatare img{border-radius:50%;opacity:0;',
      'transform:translateX(-32px);',
      'box-shadow:0 9px 28px rgba(0,0,0,.26),0 0 0 1px rgba(255,255,255,.12);',
      'transition:opacity 220ms cubic-bezier(.23,1,.32,1) calc(520ms + var(--i,0) * 70ms),',
      'transform 220ms cubic-bezier(.23,1,.32,1) calc(520ms + var(--i,0) * 70ms)}',
    '#mmFaq2.sichtbar .mmF2avatare img{opacity:1;transform:none}',

    /* ---------- Suche ---------- */
    '#mmFaq2 .mmF2suche{position:relative;margin:0 0 16px}',
    /* Die Lupe faehrt herein wie auf der Guideline-Seite (Mert, 19.08.2026:
       "soll von rechts nach links kommen und bis dahin dann anhalten, wo gerade
       dieses Suchlogo ist ... wie so ein Auto, der so durchfaehrt. Mit
       Schnelligkeit. Und dann bremsenmaessig."). Uebernommen aus glLupeFahrt.
       top:calc(50% - 8px) statt top:50%+translateY: das transform bleibt damit
       frei fuer die Fahrt - sonst wuerde die Animation die Zentrierung wegwerfen.
       transform-box/-origin sind bei SVG Pflicht, sonst dreht es um die linke
       obere Ecke der Zeichenflaeche statt um die eigene Mitte. */
    '#mmFaq2 .mmF2suche svg{position:absolute;left:15px;top:calc(50% - 9px);',
      'width:18px;height:18px;opacity:1;',
      'transform-box:fill-box;transform-origin:50% 50%;',
      'fill:none;stroke:rgba(243,233,236,.74);stroke-width:2;',
      /* z-index ist Pflicht, nicht Geschmack: das Eingabefeld hat einen
         backdrop-filter und macht damit einen eigenen Stapelkontext auf -
         ohne diese Zeile lag die Lupe UNTER dem Feld und war unsichtbar.
         Genau deshalb war auf Merts Bildschirmfoto vom 02.09.2026 keine
         Lupe zu sehen. */
      'z-index:2;',
      'stroke-linecap:round;pointer-events:none}',
    /* Die Lupe folgt erst nach dem letzten Avatar; so liest sich der Auftritt
       als Reihenfolge statt als gleichzeitig startender Effekt. */
    '#mmFaq2.sichtbar .mmF2suche svg{animation:mmF2LupeFahrt 1.16s linear .86s both}',
    '@keyframes mmF2LupeFahrt{',
      /* Anfahrt: schnell und gleichmaessig, wie ein Wagen, der schon Tempo hat */
      '0%{opacity:0;transform:translateX(var(--mmF2lupeweg,240px)) rotate(-3deg);',
        'animation-timing-function:cubic-bezier(.28,.52,.42,1)}',
      '7%{opacity:1}',
      /* Bremspunkt: die Strecke ist in der halben Zeit gefahren */
      '48%{transform:translateX(12px) rotate(-2deg);',
        'animation-timing-function:cubic-bezier(.62,0,.9,.62)}',
      /* AUFPRALL - breit und flach gedrueckt, ueber den Punkt hinausgeschoben */
      '60%{transform:translateX(-9px) scale(1.2,.82) rotate(8deg);',
        'animation-timing-function:cubic-bezier(.2,0,.3,1)}',
      /* federt ueberhoeht zurueck: jetzt schmal und hoch */
      '71%{transform:translateX(5px) scale(.9,1.12) rotate(-5deg)}',
      '81%{transform:translateX(-2.5px) scale(1.06,.96) rotate(2.5deg)}',
      '90%{transform:translateX(1px) scale(.98,1.02) rotate(-1deg)}',
      '96%{transform:translateX(-.4px) scale(1.01,.99) rotate(.4deg)}',
      '100%{opacity:1;transform:translateX(0) scale(1) rotate(0)}}',
    /* Wer ins Suchfeld geht, bekommt dieselbe Bewegung noch einmal - die Lupe
       antwortet auf den Klick, statt nur dazustehen. */
    '#mmFaq2 .mmF2suche:focus-within svg{opacity:1;stroke:#F3E9EC;',
      'animation:mmF2LupeWink .5s cubic-bezier(.34,1.3,.64,1)}',
    '@keyframes mmF2LupeWink{0%{transform:rotate(0) scale(1)}',
      '30%{transform:rotate(-9deg) scale(1.1)}',
      '62%{transform:rotate(8deg) scale(1.06)}',
      '100%{transform:rotate(0) scale(1)}}',
    '#mmFaq2 .mmF2feldein{width:100%;border-radius:999px;border:1px solid rgba(255,255,255,.19);',
      'background-color:rgba(30,21,25,.64);',
      'background-image:radial-gradient(circle at 18% 0,rgba(255,255,255,.11),transparent 36%),',
      'radial-gradient(circle at 88% 115%,rgba(255,113,133,.08),transparent 42%);',
      'box-shadow:inset 0 1px 0 rgba(255,255,255,.16),inset 0 -1px 0 rgba(255,255,255,.04),',
      '0 18px 46px rgba(0,0,0,.22);',
      'color:#F3E9EC;padding:13px 42px 13px 42px;',
      'font-family:inherit;font-size:.9rem;outline:0;',
      'transition:border-color .3s ease,background .3s ease,box-shadow .3s ease}',
    '#mmFaq2 .mmF2feldein::placeholder{color:rgba(243,233,236,.38)}',
    '#mmFaq2 .mmF2feldein:focus{border-color:rgba(255,113,133,.72);background-color:rgba(38,27,32,.72);',
      'box-shadow:inset 0 1px 0 rgba(255,255,255,.18),0 0 0 3px rgba(255,113,133,.10),',
      '0 20px 50px rgba(0,0,0,.25)}',
    '#mmFaq2 .mmF2weg{position:absolute;right:8px;top:50%;transform:translateY(-50%);',
      'width:28px;height:28px;border:0;border-radius:50%;cursor:pointer;opacity:0;',
      'pointer-events:none;background:rgba(243,233,236,.12);color:#F3E9EC;font-size:1rem;',
      'line-height:1;transition:opacity .25s ease}',
    '#mmFaq2.mmSucht .mmF2weg{opacity:1;pointer-events:auto}',

    /* ---------- Stufe 1: Themenkacheln ---------- */
    '#mmFaq2 .mmF2themen{display:grid;grid-template-columns:1fr 1fr;gap:10px}',
    '#mmFaq2 .mmF2themen .mmF2thema:nth-child(5){grid-column:1 / -1}',
    '@media(min-width:680px){#mmFaq2 .mmF2themen{grid-template-columns:repeat(3,1fr)}',
      '#mmFaq2 .mmF2themen .mmF2thema:nth-child(5){grid-column:auto}}',
    '#mmFaq2 .mmF2thema{position:relative;overflow:visible;text-align:left;cursor:pointer;',
      'border:1px solid rgba(var(--mmF2rgb),.32);border-radius:20px;',
      'background:linear-gradient(145deg,rgba(255,255,255,.085),rgba(255,255,255,.018) 58%),',
      'rgba(30,21,25,.76);box-shadow:inset 0 1px 0 rgba(255,255,255,.15),',
      'inset 0 -1px 0 rgba(var(--mmF2rgb),.07),0 18px 42px rgba(0,0,0,.22);',
      'padding:15px 15px 14px;color:#F3E9EC;font-family:inherit;',
      'opacity:0;transform:translateY(14px);',
      'transition:border-color .3s ease,background .3s ease,box-shadow .3s ease,transform .3s ' + K + '}',
    '#mmFaq2 .mmF2thema:before{content:"";position:absolute;inset:0;border-radius:inherit;pointer-events:none;',
      'background:radial-gradient(circle at 16% 5%,rgba(var(--mmF2rgb),.22),transparent 44%);opacity:.82}',
    '#mmFaq2 .mmF2thema:after{content:"";position:absolute;z-index:2;inset:-1px;border-radius:inherit;',
      'box-sizing:border-box;padding:1.5px;pointer-events:none;',
      'background:linear-gradient(112deg,rgba(var(--mmF2rgb),.14) 4%,rgba(var(--mmF2rgb),.5) 24%,',
      'rgba(var(--mmF2rgb),1) 38%,rgba(255,255,255,.96) 47%,rgba(var(--mmF2rgb),1) 56%,',
      'rgba(var(--mmF2rgb),.48) 72%,rgba(var(--mmF2rgb),.14) 94%);',
      'background-size:280% 100%;background-position:118% 50%;opacity:.58;',
      '-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);',
      '-webkit-mask-composite:xor;mask-composite:exclude;',
      'filter:drop-shadow(0 0 5px rgba(var(--mmF2rgb),.26));',
      'animation:mmF2RandLicht 6.2s cubic-bezier(.45,0,.25,1) infinite;',
      'animation-delay:calc(var(--i,0) * -.83s);animation-play-state:paused}',
    '#mmFaq2.mmF2RandAktiv:not(.mmOffen):not(.mmSucht) .mmF2thema:after{animation-play-state:running}',
    '@keyframes mmF2RandLicht{0%,100%{background-position:118% 50%;opacity:.42}',
      '42%{opacity:.72}56%{background-position:-18% 50%;opacity:.96}72%{opacity:.6}}',
    '#mmFaq2 .mmF2thema>*{position:relative;z-index:1}',
    '#mmFaq2 .mmF2thema.mmDa{animation:mmF2Auf .5s ' + K + ' both;',
      'animation-delay:calc(var(--i,0) * 70ms)}',
    '@keyframes mmF2Auf{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}',
    '@media (hover:hover){#mmFaq2 .mmF2thema:hover{border-color:rgba(var(--mmF2rgb),.68);',
      'background:linear-gradient(145deg,rgba(255,255,255,.105),rgba(var(--mmF2rgb),.055));',
      'box-shadow:inset 0 1px 0 rgba(255,255,255,.18),0 20px 46px rgba(0,0,0,.28),',
      '0 0 24px rgba(var(--mmF2rgb),.12);transform:translateY(-3px)}}',
    '#mmFaq2 .mmF2thema:focus-visible{outline:2px solid var(--mmF2farbe);outline-offset:3px}',
    '#mmFaq2 .mmF2thema svg{width:38px;height:38px;padding:8px;fill:none;stroke:var(--mmF2farbe);',
      'stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round;display:block;margin:0 0 10px;',
      'border:1px solid rgba(var(--mmF2rgb),.28);border-radius:13px;background:rgba(var(--mmF2rgb),.09);',
      'box-shadow:inset 0 1px 0 rgba(255,255,255,.12),0 7px 18px rgba(0,0,0,.18)}',
    '#mmFaq2 .mmF2tname{display:block;font-weight:700;font-size:.92rem;line-height:1.2;',
      'margin:0 0 3px;color:#F3E9EC}',
    '#mmFaq2 .mmF2tunter{display:block;font-size:.7rem;line-height:1.35;',
      'color:rgba(243,233,236,.5)!important}',
    '#mmFaq2 .mmF2tzahl{position:absolute;top:13px;right:14px;font-size:.68rem;font-weight:850;',
      'color:var(--mmF2farbe);font-variant-numeric:tabular-nums}',

    /* ---------- Stufe 2: Kopf mit Zurueck ---------- */
    '#mmFaq2 .mmF2zurueck{display:none;align-items:center;gap:10px;width:100%;cursor:pointer;',
      'border:1px solid rgba(var(--mmF2rgb),.30);border-radius:999px;',
      'background:linear-gradient(145deg,rgba(255,255,255,.075),rgba(var(--mmF2rgb),.04));',
      'box-shadow:inset 0 1px 0 rgba(255,255,255,.12),0 12px 30px rgba(0,0,0,.18);',
      'color:#F3E9EC;font-family:inherit;font-size:.8rem;font-weight:700;padding:9px 16px;',
      'margin:0 0 14px;transition:border-color .3s ease,box-shadow .3s ease}',
    '#mmFaq2.mmOffen .mmF2zurueck{display:flex;animation:mmF2Auf .4s ' + K + ' both}',
    '#mmFaq2 .mmF2zurueck:hover{border-color:rgba(var(--mmF2rgb),.68);',
      'box-shadow:inset 0 1px 0 rgba(255,255,255,.14),0 14px 34px rgba(0,0,0,.22)}',
    '#mmFaq2 .mmF2zurueck b{color:var(--mmF2farbe);font-size:1.05rem;line-height:1}',
    '#mmFaq2 .mmF2zurueck span{color:rgba(243,233,236,.45);font-weight:600}',
    '#mmFaq2.mmOffen .mmF2themen,#mmFaq2.mmSucht .mmF2themen{display:none}',
    '#mmFaq2.mmSucht .mmF2zurueck{display:none}',

    /* ---------- Fragenliste ---------- */
    '#mmFaq2 .mmF2liste{display:none;flex-direction:column;gap:10px}',
    '#mmFaq2.mmOffen .mmF2liste,#mmFaq2.mmSucht .mmF2liste{display:flex}',
    '#mmFaq2 .mmF2feld{border:1px solid rgba(var(--mmF2rgb),.22);border-radius:18px;',
      'background:linear-gradient(145deg,rgba(255,255,255,.065),rgba(255,255,255,.018)),',
      'rgba(30,21,25,.68);box-shadow:inset 0 1px 0 rgba(255,255,255,.10),',
      '0 14px 34px rgba(0,0,0,.17);opacity:0;transform:translateY(12px);',
      'animation:mmF2Auf .45s ' + K + ' both;animation-delay:calc(var(--i,0) * 55ms);',
      'transition:background .3s ease,border-color .3s ease,box-shadow .3s ease}',
    '#mmFaq2 .mmF2feld.auf{background:linear-gradient(145deg,rgba(255,255,255,.09),',
      'rgba(var(--mmF2rgb),.065)),rgba(30,21,25,.72);border-color:rgba(var(--mmF2rgb),.56);',
      'box-shadow:inset 0 1px 0 rgba(255,255,255,.13),0 18px 42px rgba(0,0,0,.23),',
      '0 0 22px rgba(var(--mmF2rgb),.08)}',
    '#mmFaq2 .mmF2frage{display:flex;width:100%;align-items:flex-start;',
      'justify-content:space-between;gap:14px;text-align:left;background:transparent;border:0;',
      'cursor:pointer;padding:15px 16px;font-size:.95rem;font-weight:600;font-family:inherit;',
      'line-height:1.4;color:rgba(243,233,236,.7);transition:color .3s ease}',
    '#mmFaq2 .mmF2frage>span{color:inherit}',
    '#mmFaq2 .mmF2feld.auf .mmF2frage{color:#F3E9EC}',
    '#mmFaq2 .mmF2frage:focus-visible{outline:2px solid var(--mmF2farbe);outline-offset:-3px}',
    '#mmFaq2 .mmF2frage mark{background:rgba(var(--mmF2rgb),.30);color:#fff;border-radius:3px;',
      'padding:0 2px}',
    '#mmFaq2 .mmF2herkunft{display:block;font-size:.62rem;font-weight:700;letter-spacing:.08em;',
      'text-transform:uppercase;color:var(--mmF2farbe);margin:0 0 4px}',

    /* Das Plus dreht sich zum Kreuz. */
    '#mmFaq2 .mmF2plus{position:relative;flex:0 0 auto;width:18px;height:18px;margin-top:2px;',
      'transition:transform .4s ' + K + '}',
    '#mmFaq2 .mmF2plus:before,#mmFaq2 .mmF2plus:after{content:"";position:absolute;',
      'background:rgba(243,233,236,.6);border-radius:2px;transition:background .3s ease}',
    '#mmFaq2 .mmF2plus:before{left:0;top:8px;width:18px;height:2px}',
    '#mmFaq2 .mmF2plus:after{top:0;left:8px;width:2px;height:18px;',
      'transition:transform .4s ' + K + ',background .3s ease}',
    '#mmFaq2 .mmF2feld.auf .mmF2plus{transform:rotate(135deg)}',
    '#mmFaq2 .mmF2feld.auf .mmF2plus:before,#mmFaq2 .mmF2feld.auf .mmF2plus:after{',
      'background:var(--mmF2farbe)}',

    '#mmFaq2 .mmF2antwort{height:0;overflow:hidden;transition:height .42s ' + K + '}',
    '#mmFaq2 .mmF2inhalt{padding:0 16px 17px;font-size:.86rem;line-height:1.62;',
      'color:rgba(243,233,236,.66)}',
    '#mmFaq2 .mmF2inhalt p{margin:0 0 10px}',
    '#mmFaq2 .mmF2inhalt p:last-child{margin-bottom:0}',
    '#mmFaq2 .mmF2inhalt strong,#mmFaq2 .mmF2inhalt b{color:#F3E9EC}',
    '#mmFaq2 .mmF2inhalt a{color:#F3E9EC}',

    /* Grafik in einer Antwort: NIE beschnitten (feste Regel 21.08.2026) -
       eigenes Seitenverhaeltnis, height:auto, kein cover. Die Hoechstbreite haelt
       die Antwort kurz; die Grafik ist hochkant 940x1672. */
    '#mmFaq2 .mmF2bild{display:block;margin:14px auto 6px;width:min(100%,300px);padding:0}',
    '#mmFaq2 .mmF2bild a{display:block;text-decoration:none}',
    '#mmFaq2 .mmF2bild img{display:block;width:100%;height:auto;aspect-ratio:940/1672;',
      'border-radius:12px;border:1px solid rgba(243,233,236,.14)}',
    '#mmFaq2 .mmF2bild figcaption{margin:7px 0 0;font-size:.66rem;line-height:1.4;',
      'color:rgba(243,233,236,.45);text-align:center}',

    '#mmFaq2 .mmF2leer{display:none;text-align:center;padding:26px 10px;font-size:.86rem;',
      'color:rgba(243,233,236,.5)}',
    '#mmFaq2.mmNichts .mmF2leer{display:block}',
    '#mmFaq2.mmNichts .mmF2liste{display:none}',

    '@supports ((-webkit-backdrop-filter:blur(1px)) or (backdrop-filter:blur(1px))){',
      '#mmFaq2 .mmF2feldein,#mmFaq2 .mmF2thema,#mmFaq2 .mmF2zurueck,#mmFaq2 .mmF2feld{',
      '-webkit-backdrop-filter:blur(18px) saturate(135%);backdrop-filter:blur(18px) saturate(135%)}}',
    '@media(prefers-reduced-transparency:reduce){#mmFaq2 .mmF2schein{display:none}',
      '#mmFaq2 .mmF2feldein,#mmFaq2 .mmF2thema,#mmFaq2 .mmF2zurueck,#mmFaq2 .mmF2feld{',
      'background:#1E1519!important;-webkit-backdrop-filter:none!important;backdrop-filter:none!important}}',

    '@media(prefers-reduced-motion:reduce){#mmFaq2 .mmF2suche svg,',
      '#mmFaq2.sichtbar .mmF2suche svg,#mmFaq2 .mmF2suche:focus-within svg{',
      'opacity:1!important;transform:none!important;animation:none!important}',
    '@media(prefers-reduced-motion:reduce){#mmFaq2 .mmF2auge,#mmFaq2 .mmF2auge:before,',
      '#mmFaq2 .mmF2avatare img{transform:none!important;',
        'transition:opacity .2s ease 0ms!important}',
      '#mmFaq2 .mmF2thema,#mmFaq2 .mmF2feld,',
      '#mmFaq2 .mmF2zurueck{animation:none;opacity:1;transform:none}',
      '#mmFaq2 .mmF2thema:after{animation:none!important;background-position:50% 50%;opacity:.68}',
      '#mmFaq2 .mmF2antwort{transition:none}',
      '#mmFaq2 .mmF2thema:hover{transform:none}}'
  ].join('');

  function schuetzen(s) {
    return s.replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function bauen() {
    if (document.getElementById('mmFaq2')) return true;
    var alt = document.querySelector('.st_faq-wrapper');
    var posten = [].slice.call(document.querySelectorAll('.st_faq-item'));
    if (!alt || !posten.length) return false;

    var daten = posten.map(function (p) {
      var q = p.querySelector('.st_faq-question');
      var a = p.querySelector('.st_faq-answer');
      return {
        frage: q ? q.textContent.replace(/\s+/g, ' ').trim() : '',
        html: a ? grafikEinsetzen(a.innerHTML) : ''
      };
    }).filter(function (d) { return d.frage; });
    if (!daten.length) return false;

    daten.forEach(function (d) {
      d.thema = 'dich';
      for (var i = 0; i < THEMEN.length; i++) {
        if (THEMEN[i][3].test(d.frage)) { d.thema = THEMEN[i][0]; break; }
      }
      d.suchtext = (d.frage + ' ' + d.html.replace(/<[^>]+>/g, ' '))
                   .replace(/\s+/g, ' ').toLowerCase();
    });

    var name = {}, offen = [];
    THEMEN.forEach(function (t) {
      name[t[0]] = t[1];
      var n = daten.filter(function (d) { return d.thema === t[0]; }).length;
      if (n) offen.push({ s: t[0], titel: t[1], unter: t[2], n: n });
    });
    if (!offen.length) return false;

    var st = document.createElement('style');
    st.id = 'mmFaq2-stil';
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);

    var sek = document.createElement('section');
    sek.id = 'mmFaq2';
    sek.innerHTML =
      '<span class="mmF2schein"></span>' +
      '<div class="mmF2innen">' +
        '<div class="mmF2kopf">' +
          '<p class="mmF2auge">Die häufigsten Fragen</p>' +
          '<h2>Gefragt und beantwortet</h2>' +
        '</div>' +
        '<div class="mmF2avatare"></div>' +
        '<div class="mmF2suche">' +
          '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.4"/><path d="m16 16 4 4"/></svg>' +
          '<input class="mmF2feldein" type="search" autocomplete="off" ' +
            'aria-label="In den Fragen suchen" ' +
            'placeholder="Such einfach: müde, Sport, Preis …">' +
          '<button class="mmF2weg" type="button" aria-label="Suche leeren">&times;</button>' +
        '</div>' +
        '<div class="mmF2themen">' +
          offen.map(function (o, i) {
            return '<button class="mmF2thema" type="button" data-s="' + o.s + '" ' +
                   'style="' + farbStil(o.s, i) + '">' +
                     '<svg viewBox="0 0 24 24">' + (ZEICHEN[o.s] || '') + '</svg>' +
                     '<span class="mmF2tzahl">' + o.n + '</span>' +
                     '<span class="mmF2tname">' + o.titel + '</span>' +
                     '<span class="mmF2tunter">' + o.unter + '</span>' +
                   '</button>';
          }).join('') +
        '</div>' +
        '<button class="mmF2zurueck" type="button"><b>&larr;</b>' +
          '<span class="mmF2zname"></span></button>' +
        '<div class="mmF2liste"></div>' +
        '<p class="mmF2leer">Dazu steht hier noch nichts. Schreib uns an ' +
          'info@magicmilk.de — wir antworten dir direkt.</p>' +
      '</div>';

    alt.parentNode.insertBefore(sek, alt);
    alt.style.display = 'none';

    var spalte = alt.querySelector('.st_faq-left-column');
    if (spalte) {
      sek.querySelector('.mmF2avatare').appendChild(spalte);
      [].forEach.call(spalte.querySelectorAll('img'), function (b, i) {
        b.style.setProperty('--i', i);
      });
    }

    var liste = sek.querySelector('.mmF2liste');
    var suche = sek.querySelector('.mmF2feldein');
    var weg = sek.querySelector('.mmF2weg');
    var zurueck = sek.querySelector('.mmF2zurueck');
    var zname = sek.querySelector('.mmF2zname');

    function hervor(text, wort) {
      if (!wort) return schuetzen(text);
      var i = text.toLowerCase().indexOf(wort);
      if (i < 0) return schuetzen(text);
      return schuetzen(text.slice(0, i)) + '<mark>' +
             schuetzen(text.slice(i, i + wort.length)) + '</mark>' +
             schuetzen(text.slice(i + wort.length));
    }

    function fuellen(posten, wort) {
      liste.innerHTML = posten.map(function (d, i) {
        return '<div class="mmF2feld" style="' + farbStil(d.thema, i) + '">' +
          '<button class="mmF2frage" type="button" aria-expanded="false"><span>' +
            (wort ? '<span class="mmF2herkunft">' + name[d.thema] + '</span>' : '') +
            hervor(d.frage, wort) +
          '</span><span class="mmF2plus"></span></button>' +
          '<div class="mmF2antwort"><div class="mmF2inhalt">' + d.html + '</div></div>' +
        '</div>';
      }).join('');

      [].forEach.call(liste.querySelectorAll('.mmF2frage'), function (f) {
        f.addEventListener('click', function () {
          var feld = f.parentNode;
          var kasten = feld.querySelector('.mmF2antwort');
          var inhalt = kasten.firstElementChild;
          if (feld.classList.contains('auf')) {
            kasten.style.height = inhalt.offsetHeight + 'px';
            requestAnimationFrame(function () { kasten.style.height = '0px'; });
            feld.classList.remove('auf');
            f.setAttribute('aria-expanded', 'false');
          } else {
            kasten.style.height = inhalt.offsetHeight + 'px';
            feld.classList.add('auf');
            f.setAttribute('aria-expanded', 'true');
            /* Nach der Bewegung auf auto stellen - sonst schneidet ein nachgeladenes
               Bild die Antwort ab. */
            window.setTimeout(function () {
              if (feld.classList.contains('auf')) kasten.style.height = 'auto';
            }, 440);
          }
        });
      });
      sek.classList.toggle('mmNichts', !posten.length);
    }

    var jetzigesThema = null;

    function themaOeffnen(s) {
      jetzigesThema = s;
      var p = daten.filter(function (d) { return d.thema === s; });
      var farbe = FARBEN[s] || { farbe: ROT, rgb: '229,20,42' };
      sek.style.setProperty('--mmF2farbe', farbe.farbe);
      sek.style.setProperty('--mmF2rgb', farbe.rgb);
      zname.textContent = name[s] + ' · ' + p.length + (p.length === 1 ? ' Frage' : ' Fragen');
      sek.classList.add('mmOffen');
      fuellen(p, '');
      /* Nicht scrollen, wenn die Kacheln ohnehin im Bild sind - sonst huepft die
         Seite unter dem Finger weg. */
      var o = sek.getBoundingClientRect();
      if (o.top < -40) sek.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' });
    }

    function uebersicht() {
      jetzigesThema = null;
      sek.style.removeProperty('--mmF2farbe');
      sek.style.removeProperty('--mmF2rgb');
      sek.classList.remove('mmOffen', 'mmNichts');
      liste.innerHTML = '';
      [].forEach.call(sek.querySelectorAll('.mmF2thema'), function (k) {
        k.classList.remove('mmDa');
        void k.offsetWidth;   /* Animation neu starten */
        k.classList.add('mmDa');
      });
    }

    [].forEach.call(sek.querySelectorAll('.mmF2thema'), function (k) {
      k.addEventListener('click', function () { themaOeffnen(k.dataset.s); });
    });
    zurueck.addEventListener('click', uebersicht);

    var tippUhr = null;
    function suchen() {
      var wort = suche.value.trim().toLowerCase();
      if (wort.length < 2) {
        /* Zurueck in den Zustand vor der Suche - offenes Thema oder Uebersicht. */
        sek.classList.remove('mmSucht', 'mmNichts');
        if (jetzigesThema) fuellen(daten.filter(function (d) {
          return d.thema === jetzigesThema;
        }), '');
        else liste.innerHTML = '';
        return;
      }
      sek.classList.add('mmSucht');
      fuellen(daten.filter(function (d) { return d.suchtext.indexOf(wort) > -1; }), wort);
    }
    suche.addEventListener('input', function () {
      window.clearTimeout(tippUhr);
      tippUhr = window.setTimeout(suchen, 160);
    });
    suche.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { suche.value = ''; suchen(); }
    });
    weg.addEventListener('click', function () {
      suche.value = ''; suchen(); suche.focus();
    });

    /* Wie weit die Lupe faehrt, richtet sich nach der echten Breite des
       Suchfelds. Ein fester Pixelwert waere am Handy zu weit und am breiten
       Bildschirm zu kurz; Prozent hilft nicht, weil sich transform:translateX
       bei Prozent auf das Element selbst bezieht - und das sind nur 16px. */
    function lupenStrecke() {
      var kasten = sek.querySelector('.mmF2suche');
      if (!kasten) return;
      var b = kasten.getBoundingClientRect().width;
      if (b > 0) sek.style.setProperty('--mmF2lupeweg', (b - 34) + 'px');
    }
    lupenStrecke();
    /* Beim Bauen kann die Breite noch 0 sein, wenn die Sektion weit unten
       steht und der Browser sie noch nicht ausgerechnet hat. Deshalb wird
       kurz danach nachgemessen - sonst faehrt die Lupe den Standardweg. */
    window.setTimeout(lupenStrecke, 1200);
    window.addEventListener('resize', lupenStrecke);

    /* Kacheln einblenden, sobald die Sektion ins Bild kommt. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e, b) {
        if (!e[0].isIntersecting) return;
        lupenStrecke();
        sek.classList.add('sichtbar');
        [].forEach.call(sek.querySelectorAll('.mmF2thema'), function (k) {
          k.classList.add('mmDa');
        });
        b.disconnect();
      }, { threshold: 0.12 }).observe(sek);
    } else {
      lupenStrecke();
      sek.classList.add('sichtbar');
      [].forEach.call(sek.querySelectorAll('.mmF2thema'), function (k) {
        k.classList.add('mmDa');
      });
    }

    /* Nur der aeussere Farbrand bewegt sich. Ausserhalb des sichtbaren
       Bereichs und in einem inaktiven Tab bleibt er stehen. */
    var randImBild = false;
    function randStatus() {
      sek.classList.toggle('mmF2RandAktiv', randImBild && !document.hidden);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        randImBild = e[0].isIntersecting;
        randStatus();
      }, { rootMargin: '80px 0px', threshold: 0.04 }).observe(sek);
    } else {
      randImBild = true;
      randStatus();
    }
    document.addEventListener('visibilitychange', randStatus);

    return true;
  }

  /* 02.09.2026 GEFUNDENER FEHLER: das Fenster war 16 x 700ms = 11 Sekunden.
     Die Fragen kommen aber aus einer App-Sektion, die weit unten in der Seite
     steht und erst laedt, wenn man dorthin scrollt - bei langsamer Verbindung
     also spaeter als 11 Sekunden. Dann wurde die FAQ ueberhaupt nicht gebaut
     und die alte Liste blieb stehen. Jetzt wartet ein Beobachter auf den
     Wrapper, statt auf gut Glueck zu takten. */
  var gebaut = false;
  function versuchen() {
    if (gebaut) return;
    if (bauen()) { gebaut = true; return; }
    var n = 0;
    var t = window.setInterval(function () {
      n++;
      if (bauen()) { gebaut = true; window.clearInterval(t); return; }
      if (n > 16) window.clearInterval(t);
    }, 700);
  }
  if ('MutationObserver' in window) {
    var wache = new MutationObserver(function () {
      if (gebaut) { wache.disconnect(); return; }
      if (document.querySelector('.st_faq-item') && bauen()) {
        gebaut = true; wache.disconnect();
      }
    });
    wache.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', versuchen);
  } else { versuchen(); }
  window.addEventListener('load', versuchen);
})();
